//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    partners1: {
      type: Array,
      required: false
    },
    partners2: {
      type: Array,
      required: false
    },
    partnerTitle1: {
      type: String,
      required: false
    },
    partnerTitle2: {
      type: String,
      required: false
    }
  },
  methods: {
    pictureUrl (url) {
      return this.$absoluteImageUrl(url)
    }
  }
}
